import "underscore";
import "../helpers.js";

window.Sparkle ??= {};
window.Sparkle.PageBuilder ??= {};

Sparkle.PageBuilder.Row = class Row {
  static rows = [];
  static idSequence = 0;

  static clear() {
    this.rows = [];
    return (this.idSequence = 0);
  }

  constructor(section, empty) {
    this.canAdd = this.canAdd.bind(this);
    this.notFull = this.notFull.bind(this);
    this.append = this.append.bind(this);
    this.add = this.add.bind(this);
    this.remove = this.remove.bind(this);
    this.move = this.move.bind(this);
    this.rebalance = this.rebalance.bind(this);
    this.resize = this.resize.bind(this);
    this.createElement = this.createElement.bind(this);
    this.createComponentElements = this.createComponentElements.bind(this);
    this.positionElement = this.positionElement.bind(this);
    this.section = section;
    if (empty == null) {
      empty = false;
    }
    this.empty = empty;
    this.constructor.rows.push(this);
    this.id = this.constructor.idSequence++;
    this.elems = [];
    this.components = [];
    this.element = null;
    this.height = 0;
    this.width = 0;
    this.offset = 0;
  }

  canAdd(dragData) {
    if (this.empty) {
      return true;
    } else {
      const numOfComponentsInRow = this.elems.length + 1; // All components currently plus 1 new one
      const sizeOfRowComponentsColumns = this.section.maxColumns / numOfComponentsInRow;
      const lessThanMaxElements = numOfComponentsInRow <= this.section.componentsPerRow;
      const canFit = sizeOfRowComponentsColumns >= this.section.minColumns;
      const canResize = dragData.config.minColumns ? sizeOfRowComponentsColumns >= dragData.config.minColumns : true;
      const notReplacement = this.components.length === this.elems.length;
      const unresizeableComponents = _.contains(
        this.components.map((component) => component.config.resizeable),
        false,
      );

      // canFit is whether once the row has another element the components are all
      // at least as big as they need to be
      // canResize is if we can actually resize the component to the size it needs to be to fit
      // notReplacement is if there are no replacement components in the row, maintaining backward compatability
      // components to rows with inherited components
      // todo: currently assumes the existing components in the row can be resized
      return canFit && canResize && notReplacement && !unresizeableComponents && lessThanMaxElements;
    }
  }

  notFull() {
    const numComponents = this.elems.length;
    const newColumns = this.section.maxColumns / numComponents;
    const notFull = newColumns > this.section.minColumns;
    const stillRoom = this.elems.length < 3;
    const unresizeableComponents = _.contains(
      this.components.map((component) => component.config.resizeable),
      false,
    );

    return stillRoom && notFull && !unresizeableComponents;
  }

  append(component, position) {
    if (this.components.length > 0) {
      // should go after the last component in the row
      position = this.components[this.components.length - 1].position() + 1;
    }
    // otherwise we use the position passed in because there's no easy way
    // to get the section position of a where a component would go from within a
    // row.
    return this.add(component, position, this.components.length);
  }

  add(component, position, index) {
    const previousComponent = this.section.components[position - 1];
    this.components.splice(index, 0, component);
    this.elems.splice(index, 0, component.element);
    const added = this.section.insert(position, component);

    if (added) {
      component.render();
      if (previousComponent) {
        jQuery(previousComponent.element).after(component.element);
      } else {
        // empty section or inserting at beginning
        jQuery(this.section.element).prepend(component.element);
      }
      this.rebalance();
      return this.section.reflow();
    }
  }

  remove(component) {
    let position = this.components.indexOf(component);
    this.components.splice(position, 1);
    position = this.elems.indexOf(component.element);
    this.elems.splice(position, 1);
    this.section.remove(component);
    jQuery(component.element).remove();
    this.rebalance();
    return this.section.reflow();
  }

  move(component, index) {
    const origIndex = this.components.indexOf(component);
    const toComponent = this.components[index];
    const position = toComponent.position();
    Sparkle.PageBuilder.Helpers.assert(
      origIndex > -1,
      "You must pass a component that is in the row to move it within the row",
    );
    // don't do anything if it's the same component
    if (component !== toComponent) {
      this.remove(component);
      return this.add(component, position, index);
    }
  }

  // rebalance runs when a component is added to, or removed from, a row. The goal of this function is to ensure that
  // the components in the row will fill out that row completely. For each component we set its new column width to be
  // equal to the max number of columns in a row devided by the number of components in that row. If the number of
  // components is a number that doesn't devide nicely in to the max columns set for a section then to balance the row
  // we will expand the first component to fill the remaining columns avaiable.

  rebalance() {
    const numComponents = this.elems.length;
    if (!numComponents) {
      return;
    }

    let balanceColumns = false;
    let newColumns = this.section.maxColumns / numComponents;
    if (newColumns % 1 !== 0) {
      newColumns = Math.floor(newColumns);
      balanceColumns = true;
    }
    this.components.forEach((component) => component.setColumns(newColumns));
    if (balanceColumns) {
      const remainingColumns = window.SparkleConfig.pageBuilder.maxColumnsPerRow - this.components.length * newColumns;
      return this.components[0].setColumns(newColumns + remainingColumns);
    }
  }

  resize(resized, targetColumns) {
    // get a list of all components on this row that aren't being resized.
    const others = this.components.filter((component) => component.key !== resized.key);

    // the last component on the row is special: we steal columns
    // from it if we need to, or we add columns to it if we have
    // extras.
    const lastComponent = others.pop();

    // if there were other components in the row ..
    if (lastComponent) {
      // ok, so we know how many columns we _want_ the component to be adjusted
      // to, but we need to check how many columns are actually available
      // before we can actually update the component.
      const columnsForOthers = Sparkle.PageBuilder.Helpers.sum(_.map(others, (component) => component.columns()));
      const columnsAvailable = this.section.maxColumns - columnsForOthers - lastComponent.minimumColumns();

      // if the target columns are more than the columns available,
      // reduce the number of columns we'll resize this component for.
      if (targetColumns > columnsAvailable) {
        targetColumns = columnsAvailable;
      }

      // resize the component.
      resized.setColumns(targetColumns);

      // we also need to calculate and update the number of columns for the
      // last component on the row.
      return lastComponent.setColumns(this.section.maxColumns - columnsForOthers - targetColumns);
    } else {
      // any component that is the only component on the row must
      // take up the entire row. technically we should never get
      // here because the resize tool doesn't show up in this case.
      return resized.setColumns(this.section.maxColumns);
    }
  }

  createElement() {
    if (this.empty) {
      this.element = jQuery("<div></div>", { class: "empty-drop-zone" }).appendTo(this.section.element)[0];
      this.element.dataset.componentSection = this.section.element.dataset.componentSection;
      this.element.dataset.componentSectionTitle = this.section.element.dataset.componentSectionTitle;
      return (this.element.dataset.rowId = this.id);
    } else {
      this.element = jQuery("<div></div>", { class: "drop-zone" }).appendTo(this.section.element)[0];
      this.element.dataset.rowId = this.id;
      // setTimeout to wait for reflow so positions are calculated correctly
      return setTimeout(() => this.positionElement(), 0);
    }
  }

  createComponentElements() {
    let element = undefined;
    const doc = this.element.ownerDocument;
    let index = 0;

    this.components.forEach((component) => {
      element = doc.createElement("div");
      element.innerHTML = "Drop to reorder";
      element.classList.add("reorder-placeholder");
      element.dataset.columns = component.columns();
      element.dataset.index = index;
      element.style.height = "100%";
      // Ensure the component dropzone covers the height of the row
      jQuery(this.element).append(element);
      return (index = index + 1);
    });

    return this.element.classList.add("initial-row");
  }

  positionElement() {
    if (this.elems.length === 0) {
      return;
    }

    const $firstElement = jQuery(this.elems[0]);
    const $lastElement = jQuery(this.elems[this.elems.length - 1]);
    const $parent = $lastElement.parent();

    // if we remove the component, row is not updated
    // if removed through section. todo: always use row
    // api for adding/removing instead of only using rows for drag and drop
    if ($firstElement[0] && $lastElement[0] && $parent[0] && this.element) {
      const offset = $firstElement.position();
      const right = $parent.position().left + $parent.width();
      const width = right - offset.left;
      let height = 0;

      this.elems.forEach((elem) => {
        const componentHeight = jQuery(elem).outerHeight(true);
        // plus 1 to account for border height that represents where to create new rows
        if (componentHeight > height) {
          return (height = componentHeight + 1);
        }
      });

      this.height = height;
      this.offset = offset;
      this.width = width;
      this.element.style.width = width + "px";
      this.element.style.height = height + "px";
      this.element.style.left = offset.left + "px";
      return (this.element.style.top = offset.top + "px");
    }
  }
};
